import { useInRouterContext, useSearchParams } from 'react-router';

const EMPTY_SEARCH_PARAMS = new URLSearchParams();

export function useSafeSearchParams(): URLSearchParams {
  if (!useInRouterContext()) {
    return EMPTY_SEARCH_PARAMS;
  }

  const [searchParams] = useSearchParams();
  return searchParams;
}
